<app-notification></app-notification>
<div id="bg">
  <img src="/assets/images/login-background.png" alt="" />
</div>
<div class="content-container">
  <div class="logo">
    <div class="logoText">
      <img src="/assets/images/logo.png" alt="" />
      <!-- <h1 class="user">Hi {{ user }}</h1> -->
      <h1 class="user"> Hi {{ userProfile?.firstName }}</h1>
    </div>
    <div>
      <mat-icon class="logout" (click)="onLogout($event)"
        >power_settings_new</mat-icon
      >
    </div>
  </div>

  <div class="card">
    <app-landing-card></app-landing-card>
  </div>
</div>
